import { marked } from 'marked';
import type { DocsArea } from '../console/help/docsBaseUrl';

marked.setOptions({
  gfm: true,
  breaks: true,
});

export type DocsLinkMode = 'app' | 'public';

const baseFor = (mode: DocsLinkMode) => (mode === 'app' ? '/app/docs' : '/docs');

/**
 * Convierte enlaces internos del Markdown (`consola/foo.md`, `foo.md` en misma carpeta) a rutas SPA.
 */
export function rewriteDocMarkdownLinks(md: string, area: DocsArea, mode: DocsLinkMode): string {
  const base = baseFor(mode);
  let out = md
    .replace(/\]\(consola\/([a-z0-9-]+)\.md\)/gi, `](${base}/consola/$1)`)
    .replace(/\]\(super-admin\/([a-z0-9-]+)\.md\)/gi, `](${base}/super-admin/$1)`)
    .replace(/\]\(\.\.\/README\.md\)/gi, `](${base})`)
    .replace(/\]\(README\.md\)/gi, `](${base})`);
  out = out.replace(/\]\((?!https?:\/\/)([a-z0-9-]+\.md)\)/gi, (_, file: string) => {
    const slug = file.replace(/\.md$/i, '');
    return `](${base}/${area}/${slug})`;
  });
  return out;
}

export function markdownToSafeHtml(md: string): string {
  return marked.parse(md, { async: false }) as string;
}
